










import {
  Vue,
  Component,
  Prop,
} from 'vue-property-decorator';
import UserProfile from '@/domain/access/domain/profile.enum';

@Component
export default class ProfileSelect extends Vue {
  @Prop({
    type: String,
    required: true,
  })
  private value!: string;

  private items: any[] = [
    { text: 'Usuário', value: UserProfile.USER },
    { text: 'Supervisor', value: UserProfile.SUPERVISOR },
    { text: 'GP', value: UserProfile.GP },
    { text: 'Atendimento', value: UserProfile.CUSTOMER_SUCCESS },
  ];

  private input(value: string): void {
    this.$emit('input', value);
  }
}
